
// these properties will be available from anywhere via this.property
export const constants = {
    isTouch: "ontouchstart" in window ? function () {document.body.classList.add("touch"); return true;}() : function () {document.body.classList.add("no-touch"); return false;}(),
    isSafari: !!navigator.userAgent.match(/safari/i) && !navigator.userAgent.match(/chrome/i) && typeof document.body.style.webkitFilter !== "undefined" && !window.chrome ? function () {document.body.classList.add("safari"); return true;}() : function () {return false;}(),
    isIE: /MSIE|Trident/.test(window.navigator.userAgent),
    _window: window,
    _document: document,
    _html: document.documentElement,
    _body: window.body,
    $window: $(window),
    $document: $(document),
    $body: $("body"),
    rtl: !!document.querySelector("html").getAttribute("dir")
};

export const bodyLock = {
    parentElements: $("html, body"),
    mainContainer: $(".main"),
    windowWidth: constants._window.innerWidth,
    scrollTop: 0,

    lockBody() {
        if (constants._window.pageYOffset) {
            this.scrollTop = constants._window.pageYOffset;
            this.mainContainer.css({
                top: -(this.scrollTop)
            });
        }
        this.parentElements.css({
            maxHeight: "100vh",
            overflow: "hidden"
        });
    },

    unlockBody() {
        this.parentElements.css({
            maxHeight: "none",
            overflow: ""
        });
        this.mainContainer.css({
            top: ""
        });
        constants._window.scrollTo(0, this.scrollTop);
        constants._window.setTimeout(function () {
            bodyLock.scrollTop = null;
        }, 0);
    }
};



// WEBPACK FOOTER //
// ./assets/js/modules/module.js